<div class="image_upload_container">

    <div class="modal-header">

        <h4>File View</h4>

    </div>

    <div class="modal-body">

        <img *ngIf="fileType !== constants.FILE_TYPE_PDF" [src]="utils.isEmpty(fileBase64Data) === true ? 'assets/images/defaultImage.png' : fileBase64Data">

        <pdf-viewer *ngIf="fileType === constants.FILE_TYPE_PDF" [src]="pdfSrc" [fit-to-page]="true"></pdf-viewer>

    </div>

    <div class="modal-footer">

        <button type="button" class="btn" (click)="closeModal()">OK</button>

    </div>

</div>
